import React from 'react';
import { useNavigate } from 'react-router-dom';
import './ServicePage.css';

function WiFiSetup() {
  const navigate = useNavigate();
  return (
    <div className="service-page">
      <header className="service-header">
        <h1>WiFi Setup</h1>
        <p>High-performance WiFi networks for offices, hotels, schools and public venues.</p>
      </header>
      <button className="back-button" onClick={() => navigate(-1)}>← Back</button>
      <div className="service-container">
        <section className="service-section">
          <h3>What We Do</h3>
          <ul>
            <li>Site surveys and capacity planning</li>
            <li>Access point placement & configuration</li>
            <li>Security configuration (WPA3, captive portals)</li>
          </ul>
        </section>

        <div className="service-cta">
          <a href="/contact">Schedule a Site Survey</a>
        </div>
      </div>
    </div>
  );
}

export default WiFiSetup;
